/* eslint-disable no-underscore-dangle */
import getEnvValue from 'commons/getEnvValue';
import isClient from 'commons/isClient';

const isRunningOnClient = isClient();

const Inspector = isRunningOnClient ? require('avo-inspector') : null;

const environmentName = isRunningOnClient
  ? getEnvValue('NEXT_PUBLIC_ENV_NAME')
  : '';

const avoInspector = isRunningOnClient
  ? new Inspector.AvoInspector({
      apiKey: '0LwnxMrVza9UwOgaWeUP',
      env:
        environmentName === 'dev' ||
        environmentName === 'test' ||
        environmentName === 'stg' ||
        environmentName === 'local'
          ? 'dev'
          : environmentName.includes('prod')
          ? 'prod'
          : environmentName,
      version: '1.0.0',
      appName: 'My App',
    })
  : null;

export default avoInspector;
